module.controller('signatureCntrl', function (esb, services, $scope, $mdDialog, $window, $timeout, $sce, theme, APIKeyGooglePlaces) {

  window.AudioContext = window.AudioContext || window.webkitAudioContext;
  navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
  window.URL = window.URL || window.webkitURL;
  $scope.signature = undefined;
  $scope.metaData = JSON.parse($window.localStorage.getItem('metadataObj'))
  $scope.metaData.instruction = $scope.metaData.instruction || {};
  $scope.metaData.constraints = $scope.metaData.constraints || {};
  $scope.theme = theme.getTheme();
  $scope.visibility = false;
  $scope.visibilityConfirm = false;
  $scope.inputType = 'password';
  $scope.inputTypeConfirm = 'password';
  
  $scope.errorApplySignature = "";

  if ($scope.theme !== null) {
    $scope.chatTheme = {
      header: { background: $scope.theme.statusbar_background_color }, footer: { background: $scope.theme.statusbar_background_color }, bars: { color: $scope.theme.statusbar_textcolor }, message_sent_background_color: { background: $scope.theme.message_sent_background_color }, sent_color: { 'border-left': '15px solid' + $scope.theme.message_sent_background_color }, message_receive_background_color: { background: $scope.theme.message_receive_background_color }, receive_color: { 'border-right': '15px solid' + $scope.theme.message_receive_background_color }, button_selection_chat: { background: $scope.theme.button_selection_chat_background_color, color: $scope.theme.button_selection_chat_textcolor },
      button_send: {
        background: $scope.theme.button_send_background_color,
        color: $scope.theme.button_send_textcolor,
        'box-shadow': '0 2px 5px 0 rgba(0, 0, 0, 0.26)'
      }
    };
  }

  $scope.files = [];
  $scope.disabled = $scope.metaData.instruction != null && $scope.metaData.instruction.enableSigning !=null && $scope.metaData.instruction.enableSigning == "AFTER_DOWNLOAD";
  $scope.showMessage = $scope.metaData.instruction != null && $scope.metaData.instruction.enableSigning !=null && $scope.metaData.instruction.enableSigning == "AFTER_DOWNLOAD";
  $scope.downloadedDocs = {};
  
  if ($scope.metaData.extra) {
    var url = JSON.parse($scope.metaData.extra);
    $scope.files = url.file;
    $scope.nameContract = url.file[0].name;
    $scope.urlContract = esb + "/security/auth/user/files/download/" + url.file[0].hash;
  }

  //if($scope.metaData.instruction){}
  $scope.signingKeyLabel = $scope.metaData.instruction.signingKeyLabel || "Contraseña";
  $scope.signingKeyLabelConfirm = $scope.metaData.instruction.signingKeyLabelConfirm || "Confirmar contraseña";
  $scope.signingKeyTitle = $scope.metaData.instruction.signingKeyTitle || "Firma de documentos";
  $scope.signingExplanation = $scope.metaData.instruction.signingExplanation || "La clave que vas a introducir ta da acceso único a tu firma electrónica para usarla en las transacciones financieras que provee nuestro servicio. Conforme el Decreto 2364 de 2012 (Noviembre 22), por medio del cual se reglamenta el articulo 7 de la ley 527 de 1999, cuando usas tu firma electrónica en entidades comerciales e instituciones financieras, éstas tienen validez jurídica de tu comprimiso. Al crear la clave tú aceptas de manera expresa e inequívoca la validez del uso de tu firma electrónica en los documentos creados para dichas transacciones financieras.";
  $scope.signingLabel = $scope.metaData.instruction.signingLabel || "Introduce una contraseña para crear la firma del documento";
  $scope.signingLabelSign = $scope.metaData.instruction.signingLabel || "Introduzca su código de firma";
  $scope.signingKeySubTitle = $scope.metaData.instruction.signingKeySubTitle || null;
  $scope.contractDownloadLabel = $scope.metaData.instruction.contractDownloadLabel || "Puede ver los documentos que va a firmar a continuación";
  $scope.isVoice = angular.equals($scope.metaData.constraints.type, "audio");
  $scope.existAudio = false;
  $scope.iconRecord = "recordon";
  $scope.iconPlay = "playoff";
  $scope.isPlayingAudio = false;
  $scope.isRecording = false;
  $scope.clock = "Presione para grabar"; // initialise the time variable
  $scope.tickInterval = 1000;
  $scope.ti = 0;
  $scope.audioSrc;
  var mytimeout;
  let shouldStop;
  let stopped;
  let mediaRecorder;
  let audio;
  var lastBlob;
  var audioKey;



 $scope.getContractUrl = function(item) {
    return esb + "/security/auth/user/files/download/" + item.hash;
  }

  $scope.downloadContract = function(item){
      $scope.downloadedDocs[item.hash] = item.hash;
      var keys = Object.keys($scope.downloadedDocs);   
      if($scope.disabled) {
        if($scope.files.length == keys.length) {
            $scope.disabled = false;
        } 
        else {
          $scope.disabled = true;
        }
    }
  }
  $scope.closeDialog = function () {
    $mdDialog.cancel();
  };

  $scope.show_hide_password = function (input) {
    if ($scope.visibility === false) {
      $scope.visibility = true;
      $scope.inputType = 'text';
    }
    else {
      $scope.visibility = false;
      $scope.inputType = 'password';
    }
  }

  $scope.show_hide_password_confirm = function (input) {
    if ($scope.visibilityConfirm === false) {
      $scope.visibilityConfirm = true;
      $scope.inputTypeConfirm = 'text';
    }
    else {
      $scope.visibilityConfirm = false;
      $scope.inputTypeConfirm = 'password';
    }
  }

  $scope.createSignature = function () {
    $scope.progressCircular = true;
    if (navigator.geolocation){
      var showLockMessage = false;
      if(!$window.localStorage.getItem("locationPermission")){            
        $scope.showAlert("Estimado usuario, los permisos de ubicación son necesarios para una mejor experiencia en la solicitud de créditos.");
      }
      else{
        if( $window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") === 'lock')
          showLockMessage = true;
      }

      navigator.geolocation.getCurrentPosition(function (position){
        $window.localStorage.setItem("locationPermission", "true");
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        var location = {};
        var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng + "&key=" + APIKeyGooglePlaces +"&&sensor=true";
        fetch(url)
          .then(response => response.text())
          .then(contents => {
            var data = JSON.parse(contents);
            if (data.results[0]) {
              location.longitude = lng;
              location.latitude = lat;
              location.addressLine = data.results[0].formatted_address;
              location.label = "REGISTER";
              for (var i = 0; i < data.results[0].address_components.length; i++) {
                if (data.results[0].address_components[i].types[0] == "administrative_area_level_2")
                  location.locality = data.results[0].address_components[i].long_name;
                if (data.results[0].address_components[i].types[0] == "postal_code")
                  location.postalCode = data.results[0].address_components[i].long_name;
                if (data.results[0].address_components[i].types[0] == "country") {
                  location.country = data.results[0].address_components[i].short_name;
                  location.countrycode = data.results[0].address_components[i].short_name;
                  location.identifier = 0;
                }
              }
            }
            $scope.signature.location = location;
            services.signature('bearer ' + $window.localStorage.getItem('access_token1')).signing({}, $scope.signature, function (response) {
              $scope.progressCircular = undefined;
              if (response.code === 1)
                $scope.closeDialog();
            });
          })
          .catch(() => console.log("Can’t access " + url + " response. Blocked by browser?"))

      },
      function(err){
        switch (err.code) {
          // PERMISSION_DENIED
          case 1:
            console.log('Permission denied')
            $window.localStorage.setItem("locationPermission", "lock");               
            break
          // POSITION_UNAVAILABLE
          case 2:
            console.log('Permission allowed, location disabled')
            break
          // TIMEOUT
          case 3:
            console.log('Permission allowed, timeout reached')
            break
        }

        services.signature('bearer ' + $window.localStorage.getItem('access_token1')).signing({}, $scope.signature, function (response) {
          $scope.progressCircular = undefined;
          if (response.code === 1)
            $scope.closeDialog();
        });

      });

    } 
    else{
      services.signature('bearer ' + $window.localStorage.getItem('access_token1')).signing({}, $scope.signature, function (response) {
        $scope.progressCircular = undefined;
        if (response.code === 1)
          $scope.closeDialog();
      });

    }
    
 
    
  }
  function jsonConcat(o1, o2) {
    for (var key in o2) {
      o1[key] = o2[key];
    }
    return o1;
  }


  function stopRecord() {
    $scope.isRecording = false;
    $scope.iconRecord = "recordon";
    $scope.existAudio = true;
    $timeout.cancel(mytimeout);
    shouldStop = true;
    $scope.isPlayingAudio = false;
    $scope.clock = "Presione para grabar";

  }

  $scope.stopPlayPublic = function () {
    $scope.isPlayingAudio = false;
    $scope.iconPlay = "playoff";
  }

  function pausePlay() {
    $scope.isPlayingAudio = false;
    $scope.iconPlay = "playoff";
  }

  $scope.startRecord = function () {
    if ($scope.isRecording) {
      stopRecord();
    }
    else {
      navigator.mediaDevices.getUserMedia({ "audio": true })
      .then(handleSuccess)
      .catch(errorCallback);
      
    }

  }

  let errorCallback = (err) => {
    
    var message = "";
    if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
      message = "El micrófono es requerido para utilizar esta funcionalidad";
  } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
    message = "Debe habilitar los permisos de micrófono";
  } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
    message = "Ha ocurrido un error al activar el micrófono";
  } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
      //permission denied in browser 
      message = "Debe habilitar los permisos de micrófono";

  } else if (err.name == "TypeError" || err.name == "TypeError") {
    message = "Ha ocurrido un error al activar el micrófono";
  } else {
    message = "Debe habilitar los permisos de micrófono";
  }
  alert(message);
    console.log('navigator.getUserMedia error: ', err);
  };


  let handleSuccess = function (stream) {
    let options;
    let recordedChunks = [];
    shouldStop = false;
    stopped = false;
    mediaRecorder = new MediaRecorder(stream);
    if (audio != null) {
      audio.pause();
      audio.currentTime = 0;
    }
    $scope.isRecording = true;
    $scope.iconRecord = "stoponn";
    $scope.ti = 0;

    mediaRecorder.start(10);
    mytimeout = $timeout(tick, $scope.tickInterval);
    mediaRecorder.addEventListener('dataavailable', function (e) {
      if (e.data.size > 0) {
        recordedChunks.push(e.data);
        console.log(e.data);
      }

      if (shouldStop === true && stopped === false) {
        console.log('Stop');
        mediaRecorder.stop();
        stream.getAudioTracks().forEach(function (track) {
          track.stop();
        });
        stopped = true;
      }
    });

    mediaRecorder.addEventListener('start', function (e) {
      console.log('Started, state = ' + mediaRecorder.state);
    });

    mediaRecorder.addEventListener('stop', function () {
      audio = document.getElementById('audio');
      lastBlob = new Blob(recordedChunks,{type:'audio/aac'});
      audio.src = URL.createObjectURL(lastBlob);
    });

    mediaRecorder.addEventListener('warning', function (e) {
      log('Warning: ' + e);
    });

    mediaRecorder.addEventListener('error', evt => {
      console.log(evt);
      reject(evt);
    });
  };

  var tick = function () {
    $scope.ti++;
    var hr = (Math.floor($scope.ti / 3600) < 10) ? ("0" + Math.floor($scope.ti / 3600)) : (Math.floor($scope.ti / 3600));
    var min = (Math.floor($scope.ti / 60) < 10) ? ("0" + Math.floor($scope.ti / 60)) : (Math.floor($scope.ti / 60));
    var sec = $scope.ti % 60 < 10 ? ("0" + $scope.ti % 60) : ($scope.ti % 60);
    $scope.clock =  min + ":" + sec;
    mytimeout = $timeout(tick, $scope.tickInterval);
  }

  $scope.startPlay = function () {
    if ($scope.isPlayingAudio) {
      pausePlay();
    }
    else {
      $scope.isPlayingAudio = true;
      $scope.iconPlay = "pauseon";
    }

  }


  $scope.sendAudio = function(){
    $scope.progressCircular = "ok";
    const payload = new FormData();
    payload.append('type', 'voice');
    payload.append('fileExtension', 'aac');
    payload.append('latitude', "1");
    payload.append('longitude', "1");
    payload.append('file', lastBlob, 'voicesignature.aac');

    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
        $scope.progressCircular = undefined;
        if(response.data.key){
        audioKey = response.data.key;
          console.log(response.data)
          $scope.signature = {};
          $scope.signature.key = "";
          $scope.submitSignature();
        }
    });
  }

  $scope.submitSignaturePublic = function () {
    if($scope.isVoice){
      $scope.sendAudio();
    }
    else{
      $scope.submitSignature();
    }

  }

  $scope.renderHtml = function(htmlCode) {
    if(htmlCode){
      return $sce.trustAsHtml(htmlCode);
    }
  };

  function report(state) {
    console.log('Permission ' + state);
  }

  function empty(){

  };

  function errorLocation(){
    $scope.progressCircular = undefined;
    $scope.showAlert('Debe activar los permisos de ubicación');
  };


  function signatureDataJson(dataJson){
    services.signature('bearer ' + $window.localStorage.getItem('access_token1')).apply({}, dataJson, function (response) {
      $scope.progressCircular = undefined;
      if (response.code === 1)
        $scope.closeDialog();
      else{
        $scope.passwordError = true;
        switch(response.code){
          case -5:
            if(!$scope.isVoice)
               $scope.errorApplySignature = 'Contraseña incorrecta, intente de nuevo';
           else
               $scope.errorApplySignature = response.message;
          break;

          case -66:
              $scope.errorApplySignature = 'El documento ya ha sido firmado';
          break;

          case -103:
              $scope.errorApplySignature = 'La firma no ha sido creada';
          break;

          default:
            $scope.errorApplySignature = response.message;
        }
      }

    });
  }

  $scope.submitSignature = function () {

    $scope.progressCircular = true;
    var dataJson = jsonConcat($scope.signature, JSON.parse($scope.metaData.extra));
    var objFile = JSON.parse($scope.metaData.extra);
    dataJson.agaMetaDataQuery = dataJson.agaQuery;
    dataJson.agaMetaDataQueryValue = dataJson.agaIndex;
    dataJson.files = [];
    
    delete dataJson["agaQuery"];
    delete dataJson["agaIndex"];
    delete dataJson["file"];

    if($scope.isVoice){
      dataJson.audioFileHash = audioKey;
      dataJson.type = "VOICE";
    }

    if(objFile && objFile.file){
      for (var i = 0; i < objFile.file.length; i++)
      dataJson.files[i] = objFile.file[i].hash;
    }

    if (navigator.geolocation) {
      var showLockMessage = false;
      if(!$window.localStorage.getItem("locationPermission")){            
        $scope.showAlert("Estimado usuario, los permisos de ubicación son necesarios para una mejor experiencia en la solicitud de créditos.");
      }
      else{
        if( $window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") === 'lock')
          showLockMessage = true;
      }

      navigator.geolocation.getCurrentPosition(function(position){
        $window.localStorage.setItem("locationPermission", "true");
        dataJson.location = { latitude: position.coords.latitude, longitude: position.coords.longitude };
        signatureDataJson(dataJson);

      }, function (err){

        switch (err.code) {
          // PERMISSION_DENIED
          case 1:
            console.log('Permission denied')
            $window.localStorage.setItem("locationPermission", "lock");               
            break
          // POSITION_UNAVAILABLE
          case 2:
            console.log('Permission allowed, location disabled')
            break
          // TIMEOUT
          case 3:
            console.log('Permission allowed, timeout reached')
            break
        }

        signatureDataJson(dataJson);

      });
     



    }
    else{
      signatureDataJson(dataJson);

    }
    
    
 


  }

  $scope.showAlert = function(msg, title) {
    $scope.progress = undefined;
    $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#popupContainer"))).title(msg).clickOutsideToClose(false).textContent(title).ariaLabel("Alert Dialog Demo").ok("Ok"))
};

});
